var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card card-chat-booking float-left ml-3" }, [
    _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "mb-3" }, [
        _c("b", [_vm._v(_vm._s(_vm.message.text))])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "mb-4" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("message.bank_transfer.confirm_bank_transfer01")) +
              "\n        "
          ),
          _c("div", [_c("strong", [_vm._v(_vm._s(_vm.expireDateTime))])])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mb-4" }, [
          _c("h3", [
            _vm._v("ยอดที่ต้องชำระ: "),
            _c("span", { staticClass: "text-orange" }, [
              _vm._v(" " + _vm._s(_vm._f("currency")(_vm.totalPrice)) + " ")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", [
          _c("img", {
            staticClass: "mb-2",
            attrs: {
              src: _vm.globalState.bankAccountData.image_url,
              width: "160"
            }
          })
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            _vm._s(_vm.$t("message.bank_transfer.account_name")) +
              ": " +
              _vm._s(_vm._f("multiLangName")(_vm.globalState.bankAccountData))
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex align-items-center justify-content-center" },
          [
            _c("div", { staticClass: "flex-grow-1" }, [
              _c("div", [
                _vm._v(
                  _vm._s(_vm.$t("message.bank_transfer.account")) +
                    ": " +
                    _vm._s(_vm.globalState.bankAccountData.account_number)
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-right" }, [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "clipboard",
                      rawName: "v-clipboard:copy",
                      value: _vm.globalState.bankAccountData.account_number,
                      expression: "globalState.bankAccountData.account_number",
                      arg: "copy"
                    }
                  ],
                  staticClass: "btn btn-outline-info",
                  on: {
                    click: function($event) {
                      _vm.isCopied = true
                    }
                  }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.isCopied
                          ? _vm.$t("message.button.copied")
                          : _vm.$t("message.button.copy")
                      ) +
                      "\n          "
                  )
                ]
              )
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "text-remark my-3" }, [
          _vm._v(
            "\n        หลังจากที่คุณทำการโอนเงินแล้ว กรุณาแนบรูปหลักฐานการโอน\n      "
          )
        ]),
        _vm._v(" "),
        !_vm.uploadSuccess
          ? _c(
              "div",
              [
                _c("vue-dropzone", {
                  ref: "vueDropzone",
                  staticClass: "dropzone-dashed",
                  attrs: { id: "dropzone", options: _vm.dropzoneOptions },
                  on: {
                    "vdropzone-max-files-exceeded":
                      _vm.vueDropZoneMaxFilesExceeded,
                    "vdropzone-sending": _vm.vueDropZoneAddParams,
                    "vdropzone-mounted": _vm.vueDropZoneMounted,
                    "vdropzone-success": _vm.vueDropZoneSuccess
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "text-remark mt-2" }, [
                  _vm._v(
                    "\n          แนบรูปสลิป png หรือ jpg ขนาดไม่เกิน 5 MB\n        "
                  )
                ])
              ],
              1
            )
          : _c("div", { staticClass: "text-center" }, [
              _c("i", { staticClass: "fas fa-check-circle -status-accepted" }),
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("message.bank_transfer.upload_success")) +
                  "\n      "
              )
            ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e7026b6", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e7026b6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chatBooking/components/BankTransferMessage.vue
// module id = 2084
// module chunks = 0